import { useFailures } from "@/stores/failures";
import { useMyDayPlanStore } from "@/stores/myDayPlan";
import { purgeDocumentCache } from "@/lib/swClient";
import { deleteLegacySnapshots } from "@/lib/localDb";
import { disconnectLiveSync } from "@/lib/liveSync";
import { wipeLocalCopy } from "@/lib/syncEngine";

// Wipes everything this tab remembers about the user who signed out: the local copy, the
// SW document cache and the module-level Zustand stores. The stores are singletons, so
// without an explicit reset they survive a sign-out/sign-in within one tab.
// useMyDayPlanStore carries the task titles themselves (tasksMeta/preview), and its modal
// renders off `open` alone, with no check of who is signed in now. Called both from the
// sign-out button and from redirectToSignIn() — the session may expire without an
// explicit sign-out.
export async function resetClientState(): Promise<void> {
  const wiping = wipeLocalCopy();
  disconnectLiveSync();
  deleteLegacySnapshots();
  useFailures.setState({ failures: [] });
  useMyDayPlanStore.setState({
    open: false,
    stage: "builder",
    strategy: "",
    prompt: "",
    taskIndex: {},
    tasksMeta: {},
    response: "",
    parseError: null,
    preview: [],
    ignoredCount: 0,
    currentMyDayIds: [],
    loadingPrompt: false,
  });
  await Promise.all([purgeDocumentCache(), wiping]);
}
